var _style, _g, _defs, _path, _defs2, _path2, _path3, _defs3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _line, _path30, _g2, _defs5, _path31, _path32, _polyline, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMtWice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#4C4C4C;}\n\t.st4{opacity:0.5;clip-path:url(#SVGID_4_);}\n\t.st5{clip-path:url(#SVGID_4_);fill:#4C4C4C;}\n\t.st6{clip-path:url(#SVGID_6_);fill:#4C4C4C;}\n\t.st7{fill:#808080;}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:#4C4C4C;}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{clip-path:url(#SVGID_10_);fill:none;stroke:#808080;stroke-width:2;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#808080;stroke-width:2;stroke-miterlimit:10;}\n\t.st14{clip-path:url(#SVGID_12_);}\n\t.st15{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st16{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "colour"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M244.1,441.2c0-1.8-3.5-3.2-7.8-3.2s-7.8,1.4-7.8,3.2c0,0.8,0,23.9,0,24.7c0,1.8,3.5,3.2,7.8,3.2 s7.8-1.4,7.8-3.2C244.1,465.1,244.1,442,244.1,441.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.1,441.2c0-1.8-3.5-3.2-7.8-3.2s-7.8,1.4-7.8,3.2c0,0.8,0,12.1,0,12.9c1.5-1.2,3.9-2.8,7.8-2.8 c3.8,0,6.2,1.4,7.8,2.8C244.1,453.3,244.1,442,244.1,441.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M347.3,381.5c0-1.8-3.5-3.2-7.8-3.2c-4.3,0-7.8,1.4-7.8,3.2c0,0.8,0,23.9,0,24.7c0,1.8,3.5,3.2,7.8,3.2 c4.3,0,7.8-1.4,7.8-3.2C347.3,405.5,347.3,382.3,347.3,381.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.1,441.2c0-1.8-3.5-3.2-7.8-3.2s-7.8,1.4-7.8,3.2c0,0.8,0,12.1,0,12.9c1.5-1.2,3.9-2.8,7.8-2.8 c3.8,0,6.2,1.4,7.8,2.8C244.1,453.3,244.1,442,244.1,441.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M347.3,384.3c0-1.8-3.5-3.2-7.8-3.2c-4.3,0-7.8,1.4-7.8,3.2c0,0.8,0,12.1,0,12.9c1.5-1.2,3.9-2.8,7.8-2.8 c3.8,0,6.2,1.4,7.8,2.8C347.3,396.4,347.3,385.2,347.3,384.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M148.9,415.8c0-1.8-3.5-3.2-7.8-3.2c-4.3,0-7.8,1.4-7.8,3.2c0,0.8,0,23.9,0,24.7c0,1.8,3.5,3.2,7.8,3.2 c4.3,0,7.8-1.4,7.8-3.2C148.9,439.8,148.9,416.7,148.9,415.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M148.9,418.7c0-1.8-3.5-3.2-7.8-3.2c-4.3,0-7.8,1.4-7.8,3.2c0,0.8,0,12.1,0,12.9c1.5-1.2,3.9-2.8,7.8-2.8 c3.8,0,6.2,1.4,7.8,2.8C148.9,430.7,148.9,419.5,148.9,418.7z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123.5,414.9V278.7l30.9-81.6l85.6-49.4L356.5,179l0,199.8L240,446.1C190.8,443.7,143.1,426,123.5,414.9 L123.5,414.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.4197,
    y1: 362.414,
    x2: 123.8228,
    y2: 362.414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1B1B1"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240,309.9l0,136.2c-49.2-2.5-96.9-20.1-116.5-31.2v0V278.7L240,309.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.9,194l-5.5,3.2l-30.9,81.6V290c19.6,11.1,67.3,28.8,116.5,31.2l36.4-95.9L159.9,194z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M123.5,278.7c19.6,11.1,67.3,28.8,116.5,31.2l30.9-81.6l-116.5-31.2L123.5,278.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M356.5,371.3L240,438.6c-49.2-2.5-96.9-20.1-116.5-31.2v7.5c19.6,11.1,67.3,28.8,116.5,31.2l116.5-67.3V371.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M154.4,197.2l0-113L240,34.7L356.5,66v113l-85.6,49.4C221.7,225.9,174,208.3,154.4,197.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.5775,
    y1: 131.5537,
    x2: 156.2337,
    y2: 131.5537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1B1B1"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M154.4,197.2c19.6,11.1,67.3,28.8,116.5,31.2v-113L356.5,66L240,34.7l-85.6,49.4L154.4,197.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_9_",
    points: "356.5,171.1 319,193 319,95.5 356.5,73.6  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,165.8c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,160.4c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,155c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,149.6c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,144.3c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,138.9c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,133.5c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,128.1c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,122.8c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,117.4c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,112c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,106.7c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,101.3c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,95.9c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,90.5c-11.6-1.5-27.4,7.7-39,22.7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M356.5,85.2c-11.6-1.5-27.4,7.7-39,22.7"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M154.4,92c19.6,11.1,67.3,28.8,116.5,31.2l85.6-49.4l0-7.9L240,34.7l-85.6,49.4V92z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M270.9,228.4c-49.2-2.5-96.9-20.1-116.5-31.2v-7.9c19.6,11.1,67.3,28.8,116.5,31.2l85.6-49.4v7.9L270.9,228.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 319,
    y1: 200.6,
    x2: 319,
    y2: 87.6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M270.9,213.4c-6.2-0.3-12.6-0.8-19-1.4c-4.2-0.4-8.5-2-11-3.9v-14.7c3.5-1.4,6.8-1.8,11-1.4c6.4,0.6,12.7,1.1,19,1.4 l6.6-3.8v20L270.9,213.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M264.2,196.4c2.3,0.1,4.5,0.3,6.7,0.4l6.6-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M264.2,200.9c2.3,0.1,4.5,0.3,6.7,0.4l6.6-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M277.5,201.9l-6.6,3.8c-2.2-0.1-4.5-0.2-6.7-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M264.2,209.7c2.3,0.1,4.5,0.3,6.7,0.4l6.6-3.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M252.7,209.4c3.4,0.3,6.1,0,8.9-1v-10.8c-2-1.4-5.5-2.5-8.9-2.9c-3.4-0.3-6.1,0-8.9,1l0,10.8 C245.8,207.9,249.3,209,252.7,209.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M255.8,207.6c3.4,0.3,6.1,0,8.9-1l0-10.8c-2-1.4-5.5-2.5-8.9-2.9c-3.4-0.3-6.1,0-8.9,1v10.8 C248.8,206.1,252.3,207.3,255.8,207.6z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#808080",
      strokeMiterlimit: 10
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M356.5,66l-85.6,49.4c-49.2-2.5-96.9-20.1-116.5-31.2L240,34.7L356.5,66z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st15",
    points: "277.5,224.6 277.5,111.6 161,80.3  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "H",
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 367.4,
    y1: -175.2,
    x2: 367.4,
    y2: 972.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 118.6,
    y1: -133.2,
    x2: 118.6,
    y2: 1014.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: -376.9,
    y1: 587.8,
    x2: 723.2,
    y2: -47.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: -384.4,
    y1: 805.5,
    x2: 715.6,
    y2: 170.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: -368.1,
    y1: 821.2,
    x2: 732,
    y2: 186.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: -445.8,
    y1: 522.4,
    x2: 654.2,
    y2: -112.7
  })), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 276,
    y1: -133.2,
    x2: 276,
    y2: 1014.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -836.2,
    y1: -87.2,
    x2: 1208.5,
    y2: 460.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -786.5,
    y1: -151.2,
    x2: 1258.2,
    y2: 396.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -944.1,
    y1: 125.2,
    x2: 1100.6,
    y2: 673.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -947.8,
    y1: 150.9,
    x2: 1096.9,
    y2: 698.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 243,
    y1: -110.1,
    x2: 243,
    y2: 1037.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -934.4,
    y1: -17.6,
    x2: 1110.3,
    y2: 530.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -946.9,
    y1: 19.3,
    x2: 1097.9,
    y2: 567.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: -518.1,
    y1: 777.5,
    x2: 581.9,
    y2: 142.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtWice);
export default __webpack_public_path__ + "static/media/MTWice.7eaddc02d26b48ae28c44b4165ae4c19.svg";
export { ForwardRef as ReactComponent };